import PropTypes from 'prop-types';
import ThumbIcon from '../../shared-components/icons/ThumbIcon';
import styleSheet from './styles/PositionLabel.module.scss';
import { useTranslation } from 'react-i18next';

const styles = styleSheet.locals || {};

export const PositionLabel = ({ selectedIndex, inline = false }) => {
    const { t } = useTranslation();
    const labelClassName = inline
        ? `${styles.positionLabel} ${styles.positionLabelInline}`
        : styles.positionLabel;

    const indexToOrdinalNumber = () => {
        switch (selectedIndex) {
            case 0:
                return t('common.firstAbbreviation');
            case 1:
                return t('common.secondAbbreviation');
            case 2:
                return t('common.thirdAbbreviation');
            default:
                return '';
        }
    };
    return (
        <>
            <style>{styleSheet.toString()}</style>
            <div className={labelClassName}>
                <ThumbIcon width="16" height="16" />
                <span>{indexToOrdinalNumber()}</span>
            </div>
        </>
    );
};

PositionLabel.propTypes = {
    selectedIndex: PropTypes.number,
    inline: PropTypes.bool
};
